import { createActionByUserCell, TitleCell, UnreadByTeamCell } from './Cells'
/* eslint-disable import/no-internal-modules */
import FormatCell from '@insided/deprecated-control/overview/cells/FormatCell'
import IconCell from '@insided/deprecated-control/overview/cells/IconCell'
import UserCell from '@insided/deprecated-control/overview/cells/UserCell'
import DateCell from '@insided/deprecated-control/overview/cells/DateCell'
import StatusCell from '@insided/deprecated-control/overview/cells/StatusCell'
import { addSpacesAndCapitalize, implode } from '@insided/deprecated-preact-components/utils/string'

interface Column {
  header: string
  accessor: string
  cell?: (props: any) => JSX.Element | null
  size: string
  sorting?: string
  isFixed?: boolean
  isHidden?: boolean
}

const createTitleColumn = (): Column => ({
  header: 'Title',
  accessor: 'title',
  cell: TitleCell,
  size: 'l-flexible',
  isFixed: true
})

const createProductAreasColumn = (productAreas: string[], isHidden?: boolean): Column => ({
  header: 'Product areas',
  accessor: 'productAreas',
  cell: FormatCell('productAreas', (productAreaIds: string[]) => {
    return implode(productAreaIds.map((id) => productAreas[Number(id)]))
  }),
  size: 'm-flexible',
  isHidden
})

const createContentTypeColumn = (): Column => ({
  header: 'Content type',
  accessor: 'contentType',
  cell: FormatCell('contentType', addSpacesAndCapitalize),
  size: 's'
})

const createUnreadByTeamColumn = (): Column => ({
  header: 'Unread by team',
  accessor: 'moderationStatus',
  cell: UnreadByTeamCell,
  size: 's',
  sorting: 'unreadByTeam'
})

const createPublishedInColumn = (): Column => ({
  header: 'Published in',
  accessor: 'categoryName',
  size: 'm-flexible'
})

const createLikesColumn = (isHidden?: boolean): Column => ({
  header: 'Likes',
  accessor: 'likes',
  cell: IconCell('likes', 'like'),
  size: 'xs-right',
  sorting: 'likes',
  isHidden
})

const createRepliesColumn = (): Column => ({
  header: 'Replies',
  accessor: 'replyCount',
  cell: IconCell('replyCount', 'reply'),
  size: 'xs-right',
  sorting: 'replyCount'
})

const createVotesColumn = (isHidden?: boolean): Column => ({
  header: 'Votes',
  accessor: 'votes',
  cell: IconCell('votes', 'triangle'),
  size: 'xs-right',
  sorting: 'voteCount',
  isHidden
})

const createLastActivityColumn = (): Column => ({
  header: 'Last activity',
  accessor: 'lastActivity',
  cell: createActionByUserCell('lastActivity'),
  size: 'l',
  sorting: 'lastActivityAt'
})

const createAssignedModeratorColumn = (isHidden?: boolean): Column => ({
  header: 'Assigned moderator',
  accessor: 'assignedModerator',
  cell: UserCell('assignedModerator'),
  size: 'm',
  isHidden
})

const createPublishDateColumn = (isHidden?: boolean): Column => ({
  header: 'Publish date',
  accessor: 'publishedAt',
  cell: DateCell('publishedAt'),
  sorting: 'publishedAt',
  size: 'm',
  isHidden
})

const createAuthorColumn = (isHidden?: boolean): Column => ({
  header: 'Author',
  accessor: 'author',
  cell: UserCell('author'),
  size: 'm',
  isHidden
})

const createModeratorTagsColumn = (isHidden?: boolean): Column => ({
  header: 'Moderator tags',
  accessor: 'moderatorTags',
  cell: FormatCell('moderatorTags', implode),
  size: 'm-flexible',
  isHidden
})

const createModerationLabelColumn = (isHidden?: boolean): Column => ({
  header: 'Moderation label',
  accessor: 'moderationLabel',
  size: 'm-flexible',
  isHidden
})

const createPublicTagsColumn = (isHidden?: boolean): Column => ({
  header: 'Public tags',
  accessor: 'publicTags',
  cell: FormatCell('publicTags', implode),
  size: 'm-flexible',
  isHidden
})

const createLastIdeationStatusChangeColumn = (): Column => ({
  header: 'Last ideation status change',
  accessor: 'changedIdeationStatusAt',
  cell: DateCell('changedIdeationStatusAt'),
  sorting: 'changedIdeationStatusAt',
  size: 'l'
})

const createStatusColumn = (): Column => ({
  header: 'Status',
  accessor: 'status',
  cell: StatusCell(),
  size: 'xs'
})

const createLastEditedColumn = (): Column => ({
  header: 'Last edited',
  accessor: 'last_edited_date',
  cell: createActionByUserCell('lastEdit'),
  sorting: 'lastEditedAt',
  size: 'l'
})

export {
  createTitleColumn,
  createProductAreasColumn,
  createContentTypeColumn,
  createUnreadByTeamColumn,
  createPublishedInColumn,
  createLikesColumn,
  createRepliesColumn,
  createVotesColumn,
  createLastActivityColumn,
  createAssignedModeratorColumn,
  createPublishDateColumn,
  createAuthorColumn,
  createModeratorTagsColumn,
  createModerationLabelColumn,
  createPublicTagsColumn,
  createLastIdeationStatusChangeColumn,
  createStatusColumn,
  createLastEditedColumn
}
